import { useMemo } from "react";

import { Badge, Tooltip, useTheme, IconButton, useMediaQuery } from "@mui/material";

import { paths } from "src/routes/paths";
import { useRouter } from "src/routes/hooks";

import { useTranslate } from "src/locales";
import { DueMarker } from "src/services/tasks/tasks.types";
import { useGetMyTasksQuery } from "src/services/tasks/tasks.service";

import Iconify from "src/components/iconify";

export const TasksIcon = () => {

    const { t } = useTranslate();

    const theme = useTheme();

    const router = useRouter();

    const { currentData: myTasks } = useGetMyTasksQuery({
        dueMarker: DueMarker.DUE_TODAY,
        page: 1,
        perPage: 1,
    });

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClick = async () => {
        router.push(paths.dashboard.tasks.root());
    }

    const dueTodayCount = useMemo(() => myTasks?.count || 0, [myTasks]);

    return (
        <Tooltip title={t('tasks.title')}>
            <IconButton
                onClick={handleClick}
            >
                <Badge badgeContent={dueTodayCount === 0 ? <Iconify icon="fluent-mdl2:skype-check" width={12} /> : dueTodayCount} color={dueTodayCount === 0 ? "success" : "error"} >
                    <Iconify icon="solar:checklist-minimalistic-bold" width={24} />
                </Badge>
            </IconButton>
        </Tooltip >
    );
}